import axios, { AxiosResponse } from 'axios';
import axiosCancel from 'axios-cancel';

axiosCancel(axios, {
  debug: false // default
});

const qs = require('qs');

class WbHttpClient {
	private baseUrl: string
	private config: {
		headers: {
			[name: string]: string
		}
		params?: {
			[key: string]: any
		}
		timeout?: number
		cancelToken?: any
	}

	constructor() {
		const rawBaseUrl = (window.wbConfig || {}).baseUrl;
		this.baseUrl = typeof rawBaseUrl === 'string' ? rawBaseUrl : '';
		this.config = {
			headers: { 'X-Requested-With': 'XMLHttpRequest' },
		};
	}
	get(url: string, params: Record<string, unknown> = {}, cancelToken = null) {
		this.config.params = {};
		if (Object.keys(params).length) {
			this.config.params = params;
		}

		if (cancelToken) {
			this.config.cancelToken = cancelToken;
		}

    let fullUrl = `${this.baseUrl}/${url}`;

		return axios
			.get(fullUrl, this.config)
			.catch(err => {
				if (axios.isCancel(err)) {
					console.log("API cancelled, ", err.message);
				}
				return err;
			});
	}

	post(
		url: string,
		params: Record<string, unknown> & {
			dontStringify?: boolean
		} = {},
		options: Record<string, unknown> & {
			timeout?: number
		} = {}
	) {
		try {
			// @ts-ignore
			params.YII_CSRF_TOKEN = $.ajaxSetup().data.YII_CSRF_TOKEN;
			// reset query string
			this.config.params = {};
			this.config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
			if (options.hasOwnProperty("timeout")) {
				this.config.timeout = options.timeout;
			}

			/**
			Encoding can be disabled for keys by setting the encodeValuesOnly option to true:
	
			var encodedValues = qs.stringify(
			{ a: 'b', c: ['d', 'e=f'], f: [['g'], ['h']] },
			{ encodeValuesOnly: true }
			);
			assert.equal(encodedValues,'a=b&c[0]=d&c[1]=e%3Df&f[0][0]=g&f[1][0]=h');
			*/
			if (params.dontStringify) {
				return axios.post(`${this.baseUrl}/${url}`, qs.stringify(params, { encodeValuesOnly: true }), this.config) as Promise<AxiosResponse>;
			}
			return axios.post(`${this.baseUrl}/${url}`, qs.stringify(params, { arrayFormat: 'brackets' }), this.config) as Promise<AxiosResponse>;
		} catch (error) {
			console.log(`post error -->${error}`);
		}
	}

	put(url: string, params: Record<string, unknown> = {}) {
		return axios.put(`${this.baseUrl}/${url}`, params, {
			headers: { 'X-Requested-With': 'XMLHttpRequest' },
		}) as Promise<AxiosResponse>;
	}

	delete(url: string, params: Record<string, unknown> = {}) {
		this.config.params = {};
		if (Object.keys(params).length) {
			this.config.params = params;
		}

		let fullUrl = `${this.baseUrl}/${url}`;

		return axios
			.delete(fullUrl, this.config)
			.catch(err => {
				if (axios.isCancel(err)) {
					console.log("API cancelled, ", err.message);
				}
				return err;
			});
	}
	
	postJson(
		url: string,
		body: Record<string, unknown> | object,
		options: Record<string, unknown> & { timeout?: number; cancelToken?: any } = {}
	) {
		try {
			// @ts-ignore
			const payload = { ...body, YII_CSRF_TOKEN: $.ajaxSetup().data.YII_CSRF_TOKEN };
			const config = {
				...this.config,
				params: {},
				headers: {
					...this.config.headers,
					'Content-Type': 'application/json',
				},
			};
			if (options.hasOwnProperty('timeout')) {
				config.timeout = options.timeout;
			}
			if (options.hasOwnProperty('cancelToken')) {
				config.cancelToken = options.cancelToken;
			}
			return axios.post(
				`${this.baseUrl}/${url}`,
				JSON.stringify(payload),
				config
			) as Promise<AxiosResponse>;
		} catch (error) {
			console.log(`postJson error -->${error}`);
			return Promise.reject(error) as Promise<AxiosResponse>;
		}
	}
}

export default WbHttpClient;
